import { useState, useEffect } from 'react';
import OCRHeader from 'components/ocr/OCRHeader';
import DataGridWithPagination from 'components/ui/DataGrid/DataGridWithPagination';
import OCRTemplateApi from 'api/ocr-template';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { Link, Switch, Route } from 'react-router-dom';
import NewOCRTemplate from './NewOCRTemplate';
import NotificationHelper from '@youfy/shared/helpers/NotificationHelper';
import AlertHelper from 'helpers/AlertHelper';
import AWSHelper from 'helpers/AWSHelper';

const OCRTemplatesPage = () => {
  const [state, setState] = useState({
    fetching: true,
    page: 1,
    pageSize: 50,
    order: [['created_at', 'asc']],
    search: '',
    rows: [],
    count: 0,
    sortColumns: [],
    changed: true,
  });

  const columns = [
    {
      key: 'name',
      name: 'Nome',
      sortable: false,
    },
    {
      key: 'type.name',
      name: 'Tipo',
      formatter: ({ row }) => {
        return row.type.name;
      },
      sortable: false,
    },
    {
      key: 'actions',
      name: 'Ações',
      sortable: false,
      formatter: ({ row }) => {
        return (
          <>
            <Link className="btn btn-icon btn-sm" to={`/ocr/${row.id}/edit`}>
              <FiEdit2 size={16} />
            </Link>

            <button className="btn btn-icon btn-sm ms-3" onClick={handleDelete.bind(this, row)}>
              <FiTrash2 size={16} />
            </button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async props => {
    try {
      updateState({ fetching: true });
      const { page, search, pageSize, order } = state;
      console.log('search', search);
      const data = await OCRTemplateApi.fetch({ page, search, pageSize, order, ...props });
      updateState({ ...data });
    } finally {
      updateState({ fetching: false });
    }
  };

  const updateState = data => {
    setState(prevState => {
      return { ...prevState, ...data };
    });
  };

  const handleDelete = async template => {
    try {
      const result = await AlertHelper.confirmDanger({
        title: 'Remover Template',
        text: 'Deseja realmente remover esse template',
      });

      if (result.value) {
        await OCRTemplateApi.delete(template.id);
        try {
          await AWSHelper.removeFromS3({
            Bucket: `ocr.youfy.com.br`,
            Key: `${template.id}.jpg`,
          });
        } catch (error) {
          console.log(error);
        }

        fetchData();

        NotificationHelper.snack('OCR Template removido com sucesso.');
      }
    } catch (error) {
      console.log(error);
      NotificationHelper.snack('Template não pode ser removido. Verifique se o mesmo contém itens mapeados.');
    }
  };

  const handlePageChange = page => {
    updateState({ page, changed: true });
    fetchData();
  };

  const handlePageSizeChange = ({ value }) => {
    updateState({ page: 1, pageSize: value, changed: true });
    fetchData();
  };

  const handleSearch = search => {
    updateState({ search, page: 1, changed: true });
    fetchData({ search, page: 1, changed: true });
  };

  const { page, rows, pageSize } = state;

  return (
    <>
      <OCRHeader onSearch={handleSearch}>
        <h1 className="m-0 p-0 fw-lighter">OCR Templates</h1>
      </OCRHeader>

      <div className="container">
        <DataGridWithPagination
          grid={{ columns, rows: rows }}
          pagination={{ current_page: page, count: state.count, onPageChange: handlePageChange, pageSize }}
          loading={state.fetching}
          onChangePageSize={handlePageSizeChange}
        />
      </div>

      <Switch>
        <Route exact path="/ocr/add" children={<NewOCRTemplate backUrl={'/ocr'} />} />
      </Switch>
    </>
  );
};

export default OCRTemplatesPage;
